<template>
  <div>
        <div v-if="rowData.tailoring_item_id>0" style="width: 100%; text-align: left; margin-top: -40px;">
            <h2>Material Purchase Request</h2>   
            <span>
                For {{rowData.tailoring_detail.template_name}}
            </span>
            <br>
            <span>
                Fabric#: {{rowData.fabric_detail.sku_code}}, {{rowData.fabric_detail.article_name}}
            </span>     
        </div>
        <div v-if="rowData.retail_item_id>0" style="width: 100%; text-align: left; margin-top: -40px;">
            <h2>Material Purchase Request</h2>   
            <span>
                Item#: {{rowData.retail_detail.sku_code}}, {{rowData.retail_detail.article_name}}
            </span>     
        </div>
        
        <br>        
        <div style="display: flex; flex-direction: column;">
            
            <div 
                :style="'display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;'">
                <span class="label">
                    Material Qty
                </span>
                <el-input @focus="$event.target.select()"
                    :readonly="rowData.purchase_request_id>0"
                    :id="'material_qty'"
                    @keyup.enter.native="changeFocus('material_description')"
                    v-model="rowData.purchase_request_qty"
                    type="number"
                    size="small"
                    style="width: 250px;">

                    <template slot="append">{{rowData.tailoring_item_id >0 ? rowData.fabric_detail.unit_name : rowData.retail_detail.unit_name}}</template>

                </el-input>
                
            </div>
            <br>
            <div 
                :style="'display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;'">
                <span class="label">
                    Description
                </span>
                <el-input @focus="$event.target.select()"
                    :readonly="rowData.purchase_request_id>0"
                    id="material_description"
                    @keyup.enter.native="$emit('closed')"
                    v-model="rowData.purchase_request_description"
                    size="small"
                    style="width: 250px;">
                </el-input>
                
            </div>
            <el-button 
                @click="$emit('closed')"
                size="small" 
                type="primary" 
                style="width: 70px; height: 30px; margin-top: 20px;">
                Ok
            </el-button>
        </div>
  </div>
</template>

<script>
export default {
    props: ['rowData'],
    computed: {
        getCombinationItems() {
            let list = this.rowData.combination_item_list

            list.forEach(element => {
                let tailoringItemIndex = this.rowData.tailoring_detail.combination_items.findIndex((t) => t.id === element.tailoring_item_id)
                if(tailoringItemIndex>=0) {
                    element.tailoring_item_name = this.rowData.tailoring_detail.combination_items[tailoringItemIndex].template_name
                }
            })

            return list
        }
    },
    methods: {
        closeWindow() {
            this.rowData.fabric_unit_qty = this.rowData.combination_item_list.reduce((count, element1) => {return count + parseFloat(element1.fabric_unit_qty);}, 0);
            this.$emit('closed')
        }
    },
    mounted() {
        setTimeout(() => {
            document.getElementById('material_qty').focus();
        }, 300);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SaleMaster/Form/OrderItem/PurchaseRequest.vue